import styled from 'styled-components';
import { body2, body2Bold, colors, spacing } from 'ui/theme';
import { BannerProps, BannerVariants } from './types';

export const BannerBase = styled.div<BannerProps>`
  align-items: flex-start;
  border-radius: ${spacing.threeEights};
  display: flex;
  gap: ${spacing.threeQuarter};

  &[data-variant=${BannerVariants.NEUTRAL}] {
    color: ${colors.textSecondary};
    background-color: ${colors.backgroundTertiary};
    border: ${spacing.single} solid ${colors.borderPrimary};
  }
  &[data-variant=${BannerVariants.INFO}] {
    color: ${colors.textInfo};
    background-color: ${colors.backgroundInfoSubtle};
    border: ${spacing.single} solid ${colors.borderInfoSubtle};
  }
  &[data-variant=${BannerVariants.ERROR}] {
    color: ${colors.textDestructive};
    background-color: ${colors.backgroundDestructiveSubtle};
    border: ${spacing.single} solid ${colors.borderDestructiveSubtle};
  }
  &[data-variant=${BannerVariants.SUCCESS}] {
    color: ${colors.textSuccess};
    background-color: ${colors.backgroundSuccessSubtle};
    border: ${spacing.single} solid ${colors.borderSuccessSubtle};
  }
  &[data-variant=${BannerVariants.WARNING}] {
    color: ${colors.textWarning};
    background-color: ${colors.backgroundWarningSubtle};
    border: ${spacing.single} solid ${colors.borderWarningSubtle};
  }
  &:not([data-subtle='true']) {
    padding: ${spacing.threeQuarter};
  }
  &[data-subtle='true'] {
    background-color: inherit;
    gap: ${spacing.half};
    border: none;
  }
  /**
    * The special styling for this component only comes into effect when
    * a banner has only text and a close button. When this is the case,
    * we center align the contents of the banner.
    *
    * See: https://iterable.atlassian.net/browse/FE-1306 for an example
  */
  &[data-close-button-only-variant='true'] {
    align-items: center;
  }
`;

export const BannerCloseBtnWrapper = styled.div`
  flex: none;
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  align-items: flex-start;
  width: 100%;

  &.inline-title {
    display: inline-block;

    > [data-test='banner-title'] {
      margin-right: ${spacing.quarter};
    }
  }
`;

export const BannerTitleBase = styled.span`
  ${body2Bold};
  color: inherit;
`;

export const BannerIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: ${spacing.plusQuarter};
  flex: none;
  svg {
    vertical-align: bottom;
  }
`;

export const BannerBodyBase = styled.span`
  ${body2};
  color: inherit;
  &[data-subtle='true'] {
    color: ${colors.textSecondary};
  }
`;

export const BannerActionsWrapper = styled.div`
  flex: none;
`;
